<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eWwQh8/tc-custom/9781612000213.jpg?1728851662493" alt="This image is the cover for the book Attack on Pearl Harbor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Attack on Pearl Harbor
      </h1>
      <p class="bookDescription body article font2">
        <b>“Uses modern methods of operational analysis to determine exactly how the Japanese planned and executed the great raid . . . a worthy, useful analysis” (<i>Naval History</i>).</b><br/><br/>The December 7, 1941 attack on Pearl Harbor has been portrayed by historians as a dazzling success. With most American historians concentrating on command errors and the story of participants’ experiences, the Japanese attack has never been subjected to a comprehensive critical analysis of the military side of the operation.<br/><br/>This book presents a detailed evaluation of the attack on the operational and tactical level. It examines such questions as: Was the strategy underlying the attack sound? Were there flaws in planning or execution? How did Japanese military culture influence the planning? How risky was the attack? What did the Japanese expect to achieve, compared to what they did achieve? Were there Japanese blunders? What were their consequences? What might have been the results if the attack had not benefited from the mistakes of the American commanders?<br/><br/>The book also addresses the body of folklore about the attack, assessing contentious issues such as the skill level of the Japanese aircrew; whether mini submarines torpedoed <i>Oklahoma</i> and <i>Arizona</i>, as has been recently claimed; whether the Japanese ever really considered launching a third-wave attack—and the consequences for the Naval Shipyard and the fuel storage tanks if it had been executed. In addition, the analysis has detected for the first time deceptions that a prominent Japanese participant in the attack placed into the historical record, most likely to conceal his blunders and enhance his reputation.<br/><br/>The centerpiece of the book is an analysis using modern Operations Research methods and computer simulations, as well as combat models developed between 1922 and 1946 at the US Naval War College. The analysis sheds new light on the strategy and tactics employed by Yamamoto to open the Pacific War, and offers a dramatically different appraisal of the effectiveness of the attack on Pearl Harbor.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan D. Zimm
      </h2>
      
      <p class="authorDescription body article">Dr. Alan D. Zimm is a member of the Johns Hopkins University Applied Physics Laboratory, where he heads a section in the Aviation Systems and Advanced Concepts Group. He is a former officer in the US Navy, completing his service as a Commander, and holds degrees in Physics, Operations Research, and Public Administration with a concentration on Policy Analysis and Strategic Planning.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b142f65c